// Polyfills for iPhone Safari compatibility

// Check if we need polyfills
const needsPolyfills = () => {
  const userAgent = navigator.userAgent;
  const isOldIOSSafari = /iPhone/.test(userAgent) && 
                        /Safari/.test(userAgent) && 
                        !/Chrome/.test(userAgent);
                        
  // Check for iOS version
  const iOSVersion = userAgent.match(/OS (\d+)_(\d+)/);
  if (iOSVersion) {
    const majorVersion = parseInt(iOSVersion[1], 10);
    return majorVersion < 14; // iOS versions before 14 need polyfills
  }
  
  return false;
};

// Load polyfills if needed
if (needsPolyfills()) {
  // Polyfill for optional chaining (?.)
  if (!Object.prototype.hasOwnProperty.call(window, 'optionalChainingSupport')) {
    // This will be handled by the build process
  }
  
  // Polyfill for nullish coalescing (??)
  if (!Object.prototype.hasOwnProperty.call(window, 'nullishCoalescingSupport')) {
    // This will be handled by the build process
  }
  
  // Ensure fetch is available
  if (!window.fetch) {
    console.error('Fetch API not supported - this may cause loading issues');
  }
  
  // Ensure Promise is available
  if (!window.Promise) {
    console.error('Promise not supported - this may cause loading issues');
  }
}

// Add error handling for module loading failures
window.addEventListener('error', (event) => {
  if (event.error && event.error.message) {
    const message = event.error.message.toLowerCase();
    
    // Check for syntax errors that might indicate unsupported features
    if (message.includes('syntax') || 
        message.includes('unexpected token') ||
        message.includes('invalid character')) {
      
      console.error('JavaScript syntax error detected - possibly unsupported features:', event.error);
      
      // Show user-friendly message
      const errorDiv = document.createElement('div');
      errorDiv.style.cssText = `
        position: fixed; top: 0; left: 0; right: 0; bottom: 0; z-index: 10000;
        background: white; padding: 20px; text-align: center; font-family: system-ui;
      `;
      errorDiv.innerHTML = `
        <h1>🔧 Browser Compatibility Issue</h1>
        <p>Your browser version may not support all features required by this app.</p>
        <p><strong>iPhone users:</strong> Please update to iOS 14 or later for the best experience.</p>
        <a href="https://ld-growth.com/debug.html" style="display: inline-block; background: #007bff; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; margin: 10px;">
          🔍 Run Compatibility Test
        </a>
        <br>
        <button onclick="window.location.reload()" style="background: #28a745; color: white; border: none; padding: 12px 24px; border-radius: 6px; margin: 10px; cursor: pointer;">
          🔄 Try Again
        </button>
      `;
      
      document.body.innerHTML = '';
      document.body.appendChild(errorDiv);
    }
  }
});

export default {}; 